import React, { useRef, useEffect } from 'react';
import './BakeryHero.css';

const BakeryHero = () => {
  const videoRef = useRef(null);

  // Lazy-load autoplay with IntersectionObserver
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && videoRef.current && videoRef.current.paused) {
          videoRef.current.play().catch(() => {}); // ignore autoplay errors
        }
      },
      { threshold: 0.5 }
    );
    if (videoRef.current) observer.observe(videoRef.current);
    return () => observer.disconnect();
  }, []);

  const togglePlayback = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {}); // ignore autoplay restrictions
    } else {
      video.pause();
    }
  };

  return (
    <div className="hero-container">
      <div className="hero-video-wrapper">
        <video
          ref={videoRef}
          muted
          loop
          playsInline
          preload="none"
          className="hero-video"
          onClick={togglePlayback}
          aria-label="Promotional video for Jojo's Mediterranean Grill"
          role="img"
        >
          <source
            src="https://afag.imgix.net/test/blosom-welcome-to-ktown-instagram.mp4?fm=mp4&h=1200"
            type="video/mp4"
          />
          <track
            kind="captions"
            src="data:text/vtt,WEBVTT%0A%0A00:00:00.000 --> 00:00:10.000%0AWelcome to Sushi Yu"
            srcLang="en"
            label="English captions"
            default
          />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="hero-text">
        <img 
          style={{ maxWidth: "150px", width: "100%", height: "auto" }} 
          src="https://afag.imgix.net/sushi-yu/logo-wide.png?w=800&auto=format" 
          alt="Sushi Yu Logo" 
        />
      </div>

      <button
        className="hero-toggle-button"
        onClick={togglePlayback}
        aria-label="Toggle video playback"
        aria-pressed={videoRef.current ? !videoRef.current.paused : false}
      >
        <span aria-hidden="true">❚❚</span>
        <span className="sr-only">
          {videoRef.current && !videoRef.current.paused ? 'Pause' : 'Play'} video
        </span>
      </button>
    </div>
  );
};

export default BakeryHero;
